import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../utils/apiUrl';

const cache = {};

const usePageContent = (pageId) => {
  const [content, setContent] = useState(cache[pageId] || {});
  const [loading, setLoading] = useState(!cache[pageId]);

  useEffect(() => {
    if (cache[pageId]) {
      setContent(cache[pageId]);
      setLoading(false);
      return;
    }
    let cancelled = false;
    axios.get(`${API_URL}/api/cms/public/${pageId}`)
      .then(res => {
        if (!cancelled) {
          const sections = res.data?.sections || {};
          cache[pageId] = sections;
          setContent(sections);
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [pageId]);

  const t = (key, fallback = '') => content[key] || fallback;

  return { content, loading, t };
};

export default usePageContent;
